export interface IPdfDownloadOption {
	id: string;
	label: string;
	key: string;
}

export const pdfAllCombined: IPdfDownloadOption = { 
		id: 'allCombined', 
		label: 'All combined in one file',
		key: 'all'
};

export const defaultPdfOptions: IPdfDownloadOption[] = [
    { id: 'authentication', label: 'Session Information', key: 'sessionInformation' },
    { id: 'kyc', label: 'KYC (Know your customer)', key: 'kyc' },
    { id: 'aml', label: 'AML (Anti-Money Laundering)', key: 'aml' },
    { id: 'signAgreement', label: 'Sign Agreement', key: 'signAgreement' },
    { id: 'accreditation', label: 'Accreditation Verification', key: 'accreditation' },
    { id: 'dynamicForm', label: 'Questionnaire', key: 'dynamicForm' },
    { id: 'kyb', label: 'KYB (Know your business)', key: 'kyb' },
    { id: 'proofReading', label: 'Document Review', key: 'proofReading' },
    { id: 'kybForm', label: 'Entity/KYB Document Requirements', key: 'kybForm' },
    { id: 'fundInvestment', label: 'Fund Investment', key: 'fundInvestment' },
    { id: 'form', label: 'Individual or Business Questionnaire.', key: 'form' },
    { id: 'comments', label: 'Activities', key: 'comments' },
    { id: 'linkedEsign', label: 'Linked Esign Documents', key: 'linkedEsign' },
]
